export default __webpack_public_path__ + "static/media/course2.d410d9e5.png";